import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialBattery: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12.95 4.57V1.52h6.1v3.05h4.57v25.91h1.52V3.05h-4.57V0h-9.14v3.05H6.86v27.43h1.52V4.57zM8.38 30.48h15.24V32H8.38Z\"/><path fill=\"currentColor\" d=\"M9.9 22.86h12.19v4.57H9.9Zm0-4.57h12.19v1.52H9.9Zm0-4.58h12.19v1.53H9.9Zm0-4.57h12.19v1.53H9.9Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialBattery
